import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useGlobalization } from '@Translations/useGlobalization';
import { Link, Stack, Typography } from '@mui/material';
import { openDrawer } from '@innovyze/stylovyze';

import { FullPageWrapper } from '@Utils/styles';
import { DefineFailureDefinitionDialog, DeteriorationModelsList, FailureDefinitionsList } from '@Components/overview';
import { HELP_DRAWER } from '@Components/HelpPageDrawer';
import HelpDrawer from '@Components/HelpPageDrawer';
import { ROUTES } from './PageRoutes';

export const Overview = () => {
	const { t } = useGlobalization();
	const [openDefineFailureDialog, setOpenDefineFailureDialog] = useState(false);

	const isLoading = false;
	const isWaiting = false;
	const isCreating = false;

	const dispatch = useDispatch();

	return (
		<FullPageWrapper
			className={isLoading || isWaiting || isCreating ? 'wait' : ''}
			title={t('Deterioration Model')}
			breadcrumbs={ROUTES.overview.breadcrumbs}
			applyPadding={true}
			headerUnderline>
			<DefineFailureDefinitionDialog setOpen={setOpenDefineFailureDialog} isOpen={openDefineFailureDialog} />
			<Stack spacing={2}>
				<Typography variant="body1">
					{t(
						'Predict when your assets may fail and how much useful life remains. Use these insights to prioritize work, plan budgets, and reduce risk',
					)}{' '}
					<Link
						style={{ cursor: 'pointer', textDecoration: 'none' }}
						onClick={() => {
							dispatch(openDrawer(HELP_DRAWER.OVERVIEW));
						}}>
						{t('Learn more on how to create a model')}
					</Link>
				</Typography>
				<Stack>
					<DeteriorationModelsList />
					<FailureDefinitionsList />
				</Stack>
			</Stack>
			<HelpDrawer drawerID={HELP_DRAWER.OVERVIEW} />
		</FullPageWrapper>
	);
};
